export default "__VITE_ASSET__2wcEK5ut__"